import { Box, CircularProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface LoadingFallbackProps {
  message?: string;
}

export default function LoadingFallback({
  message,
}: LoadingFallbackProps): React.ReactElement {
  const { t } = useTranslation("common");
  const fallbackMessage = message ?? t("loading", "Loading...");
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="200px"
      gap={2}
    >
      <CircularProgress size={40} />
      <Typography variant="body1" color="text.secondary">
        {fallbackMessage}
      </Typography>
    </Box>
  );
}
